import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { FaHome, FaGraduationCap, FaQuestionCircle, FaChartLine, FaComments, FaUsers, FaFlask } from 'react-icons/fa';
import AuthService from '../services/AuthService';
import GameOfLife from './GameOfLife';
import Portfolio from './Portfolio';
import soundEffects from '../utils/soundEffects';
import BottomNav from './BottomNav';
import ProfileMenu from './ProfileMenu';
import './Simulations.css';

const Simulations = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { state } = useUser();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'portfolio');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Authentication check
  useEffect(() => {
    const checkAuth = () => {
      try {
        const isAuth = AuthService.isAuthenticated();
        if (!isAuth || !state.user) {
          navigate('/login', { replace: true });
          return;
        }
        setIsAuthenticated(true);
      } catch (error) {
        navigate('/login', { replace: true });
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, [navigate, state.user]);

  // Sync tab with URL
  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab && (tab === 'portfolio' || tab === 'gameoflife')) {
      setActiveTab(tab);
    }
  }, [searchParams]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
    soundEffects.playClick();
  };

  if (loading) {
    return (
      <div className="sim-container">
        <div className="sim-loading">
          <div className="sim-loading-spinner"></div>
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  // If portfolio tab is active, render Portfolio component directly
  if (activeTab === 'portfolio') {
    return <Portfolio simulationsNav={true} onSwitchTab={() => handleTabChange('gameoflife')} />;
  }

  return (
    <div className="sim-container content-with-nav">
      {/* Top Bar */}
      <div className="sim-top-bar">
        <div className="sim-top-bar-content">
          <div className="sim-top-bar-left">
            <button 
              className="sim-back-button"
              onClick={() => navigate('/dashboard')}
            >
              ←
            </button>
            <h1 className="sim-page-title">
              <FaFlask className="sim-title-icon" />
              Simulations
            </h1>
          </div>
          <ProfileMenu />
        </div>
      </div>

      {/* Tab Switcher */}
      <div className="sim-tab-bar">
        <button
          className={`sim-tab ${activeTab === 'portfolio' ? 'active' : ''}`}
          onClick={() => handleTabChange('portfolio')}
        >
          <FaChartLine className="sim-tab-icon" />
          <span>Portfolio</span>
        </button>
        <button
          className={`sim-tab ${activeTab === 'gameoflife' ? 'active' : ''}`}
          onClick={() => handleTabChange('gameoflife')}
        >
          <span className="sim-tab-emoji">🧬</span>
          <span>Game of Life</span>
        </button>
      </div>

      {/* Content */}
      <div className="sim-content">
        {activeTab === 'gameoflife' && <GameOfLife />}
      </div>

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default Simulations;
